<div class="table-wrapper" [ngClass]="tableClass">
  <p-table #tt [value]="data" [first]="first" [rowHover]="rowHover" [rows]="rows"
    [totalRecords]="totalRecords" [lazy]="lazy" [customSort]="lazy" (onLazyLoad)="handleLazyLoad($event)"
    [sortField]="sortField" [sortOrder]="sortOrder" (onSort)="handleSort($event)" [dataKey]="dataKey"
    [selectionMode]="showCheckboxes ? 'multiple' : (selectionMode || null)"
    [(selection)]="selection" (selectionChange)="selectionChange.emit($event)">

    <!-- Кастомная иконка сортировки -->
    <ng-template pTemplate="sorticon" let-sortOrder>
      <span class="p-sortable-column-icon">
        <i class="fa-solid sort-icon" [ngClass]="{
          'fa-arrows-up-down': sortOrder === 0,
          'fa-arrow-up': sortOrder === 1,
          'fa-arrow-down': sortOrder === -1
        }"></i>
      </span>
    </ng-template>

    <!-- Заголовок -->
    <ng-template pTemplate="header">

      <!-- Режим чекбоксов: первая строка генерируется из [columns] с p-tableHeaderCheckbox -->
      <ng-container *ngIf="showCheckboxes">
        <tr>
          <th style="width: 2.25em"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <ng-container *ngFor="let col of columns">
            <th [class]="col.class || ''">{{ col.header }}</th>
          </ng-container>
        </tr>
        <!-- Дополнительные строки (фильтры) из headerDirective -->
        <ng-container *ngIf="headerDirective">
          <ng-container *ngTemplateOutlet="headerDirective.template; context: { table: tt }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- Обычный режим -->
      <ng-container *ngIf="!showCheckboxes">
        <ng-container *ngIf="headerDirective; else autoHeader">
          <ng-container *ngTemplateOutlet="headerDirective.template; context: { table: tt }"></ng-container>
        </ng-container>
        <ng-template #autoHeader>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.sortable && col.field; else unsortable"
                  [class]="col.class || ''" [pSortableColumn]="col.field">
                {{ col.header }} <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
              <ng-template #unsortable>
                <th [class]="col.class || ''">{{ col.header }}</th>
              </ng-template>
            </ng-container>
          </tr>
        </ng-template>
      </ng-container>

    </ng-template>

    <!-- Тело таблицы -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">

      <!-- Режим чекбоксов: ui-table оборачивает в <tr [pSelectableRow]>, шаблон испускает только <td> -->
      <ng-container *ngIf="showCheckboxes && bodyCellsDirective">
        <tr [pSelectableRow]="rowData">
          <td style="width: 2.25em"><p-tableCheckbox [value]="rowData"></p-tableCheckbox></td>
          <ng-container *ngTemplateOutlet="bodyCellsDirective.template; context: { $implicit: rowData, rowIndex: rowIndex }"></ng-container>
        </tr>
      </ng-container>

      <!-- Обычный режим: шаблон испускает полный <tr> -->
      <ng-container *ngIf="!showCheckboxes || !bodyCellsDirective">
        <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: rowData, rowIndex: rowIndex }"></ng-container>
      </ng-container>

    </ng-template>

    <!-- Пустое состояние -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="100" class="empty-message-cell">
          <ui-no-data message="Нет данных"></ui-no-data>
        </td>
      </tr>
    </ng-template>

  </p-table>

  <div class="table-integrated-paginator" *ngIf="showPaginator">
    <div class="table-integrated-paginator__info">
      Показано <strong>{{ getTableCountText() }}</strong> из <strong>{{ totalRecords }}</strong> записей
    </div>
    <p-paginator [rows]="rows" [totalRecords]="totalRecords" [first]="first"
      (onPageChange)="handleLazyLoad($event)"></p-paginator>
  </div>
</div>
